export const reportsRacingStartSequence = {
    namespaced: true,

    state: {
        graph: {
            selectedPiece0: null,
            selectedPiece1: null,
            selectedPiece2: null,
            visibleSeries: [],
            visibleSeriesSet: []
        }
    },

    getters: {
        graph(state) {
            return state.graph;
        },

        selectedPiece0(state) {
            return state.graph.selectedPiece0;
        },

        selectedPiece1(state) {
            return state.graph.selectedPiece1;
        },

        selectedPiece2(state) {
            return state.graph.selectedPiece2;
        },

        hasStartSequenceGraphData(state) {
            const { selectedPiece0, selectedPiece1, selectedPiece2 } = state.graph;
            return selectedPiece0 || selectedPiece1 || selectedPiece2;
        },

        visibleSeries(state) {
            return state.graph.visibleSeries;
        },

        visibleSeriesSet(state) {
            return state.graph.visibleSeriesSet;
        }
    },

    mutations: {
        setSelectedPiece(state, { index, value }) {
            state.graph[`selectedPiece${index}`] = value;
        },

        resetState(state) {
            state.graph = {
                selectedPiece0: null,
                selectedPiece1: null,
                selectedPiece2: null,
                visibleSeries: [],
                visibleSeriesSet: []
            };
        }
    }
};

export default reportsRacingStartSequence;
